import React from "react";

const NewsLetterSection = () => {
  return (
    <>
      <h2>News Letter Section</h2>
    </>
  );
};

export default NewsLetterSection;
